import React from 'react'
import { Filter, FilterComponent } from '../../_WMS/FilterComponent'
import { filterOptions } from './config'

export interface FilterOption {
  order: number
  key: string
  label: string
  type: 'numeric' | 'text' | 'range' | 'precreated' | 'custom' | 'date'
  options?: []
  Component?: React.ComponentType<ComponentProps> // Solo para 'custom'
  // Otras propiedades que puedas necesitar para tipos específicos
}

interface ComponentProps {}
interface ProductSearchProps {
  onSearchClick: (filters: Filter[]) => void
  selectedFilters: Filter[]
  setSelectedFilters: any
  includeAddButton?: boolean
  defaultSelectedFilterKey?: string
  onAddButtonClick?: () => void
  addButtonTitle?: string
  createButtonTooltip?: string
}

export const AjustReturnSearch: React.FC<ProductSearchProps> = (props) => {
  return (
    <FilterComponent
      options={filterOptions}
      {...props}
      defaultSelectedFilterKey={props.defaultSelectedFilterKey}
      selectedFilters={props.selectedFilters}
      includeSearchOnClean={true}
    />
  )
}
